import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import convertXmlToJson from 'xml-js';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import global_axios from '../../funciones_globales/interaccionapi';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarPermisoAcceso } from '../../funciones_globales/utils';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import styled from 'styled-components';
import { Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import moment from 'moment';

const LabelContadorArchivos = styled.p`
  display: inline-block;
  font-size: 11px;  
  font-weight: bold;  
`;

const columnasGridRetenciones = [	{ header: "No.", field: "NroItem", width: 30, type: "string", suppressFilter: true },
									{ header: "Fecha Emisión", field: "FechaEmision", width: 100, type: "string", suppressFilter: true },
									{ header: "Ruc Cliente", field: "Ruc", width: 110, type: "string", suppressFilter: true },
									{ header: "Nombre Cliente", field: "NombreCliente", width: 200, type: "string", suppressFilter: true },
									{ header: "Estab.", field: "Establecimiento", width: 60, type: "string", suppressFilter: true },
									{ header: "P. Emisión", field: "PtoEmision", width: 60, type: "string", suppressFilter: true },
									{ header: "Secuencial", field: "Secuencial", width: 80, type: "string", suppressFilter: true },
  									{ header: "Doc. Aplic. Ret.", field: "DocRetener", width: 120, type: "string", suppressFilter: true },
									{ header: "B. Ret. Iva", field: "BaseRetIva", width: 100, type: "num_decimal", suppressFilter: true },
									{ header: "% Ret. Iva", field: "PorcRetIva", width: 100, type: "num_decimal", suppressFilter: true },
									{ header: "Val. Ret. Iva", field: "ValRetIva", width: 100, type: "num_decimal", suppressFilter: true },
									{ header: "B. Ret. Fte.", field: "BaseRetFuente", width: 100, type: "num_decimal", suppressFilter: true },
									{ header: "% Ret. Fte.", field: "PorcRetFuente", width: 100, type: "num_decimal", suppressFilter: true },
									{ header: "Val. Ret. Fte.", field: "ValRetFuente", width: 100, type: "num_decimal", suppressFilter: true },
									{ header: "Resultado", field: "Resultado", width: 100, type: "string" },
									{ header: "Observación", field: "Observacion", width: 300, type: "string", suppressFilter: true } ];


const columnasGridRetencionesResagadas = [ { header: "", width: 30, checkboxSelection: true, suppressSorting: true, suppressMenu: true, suppressFilter: true, pinned: true, headerCheckboxSelection: true,  headerCheckboxSelectionFilteredOnly: true},...columnasGridRetenciones];

class FormCaja09 extends React.Component{
    constructor(props) {
		super(props);
		
		this.state = {
			retenciones: [],
			visualizarRezagadas: false,			
			maxArchivosRetencionPorLote: 50,
			arhivosCargados: 0,
			procesando: false,
			rucCliente: '',
			loteGenerado: null,
			fechaDesde: null,
			tipoPeriodo:'S'
		};

		this.gridRetencionesOptions = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowSelection: 'multiple',
      		singleClickEdit: true,
	  		suppressRowClickSelection: true,
			getRowStyle: (params) =>{				
				if (params.data.Resultado === 'NOK') {
					return {'background-color': '#ff4d4d'};
				}else{
					return null;
				}
			}
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.onGridReady = this.onGridReady.bind(this);
		this.limpiarDatos = this.limpiarDatos.bind(this);
		this.handleImprimir = this.handleImprimir.bind(this);
		this.procesarRetenciones = this.procesarRetenciones.bind(this);
		this.importarRetencionesResagadas = this.importarRetencionesResagadas.bind(this);
		this.reprocesarRetenciones = this.reprocesarRetenciones.bind(this);
		this.handleFileUploaderOnChange = this.handleFileUploaderOnChange.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);	
		this.changeComponents = this.changeComponents.bind(this);
	}

	componentDidMount(){
		this.props.generar_LogAuditoriaIngresoForm('0509');
		let fechaProceso = getFechaProcesoPorModulo('05');
		let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
		this.setState({fechaDesde: fechaDesde})

	}

	componentWillUnmount(){
		this.props.generar_LogAuditoriaSalidaForm('0509');
	}

	onGridReady(params) {
		this.gridRetencionesApi = params.api;
		this.gridRetencionesColumnApi = params.columnApi;
	}

	handleInputChange(event){    
		const target = event.target;       
		const name = target.name;    
		const value = target.type === 'checkbox' ? target.checked : target.value;
		this.setState({
			[name]: value
		});
	}	

	changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
	}
	

	handleFileUploaderOnChange(e){

		if(this.state.arhivosCargados === this.state.maxRetencionesPorLote){
			alert(`Solo puede cargar un máximo de: ${this.state.maxArchivosRetencionPorLote} archivos de retenciones en cada lote.`);
			return;
		}

		const filesArray = Array.from(e.target.files);
		filesArray
		.filter(archivo=>archivo.name.endsWith('.xml'))
		.forEach((archivoXml) => {

			if(this.state.arhivosCargados < this.state.maxArchivosRetencionPorLote){
			
				const fileReader = new FileReader();
				fileReader.readAsText(archivoXml);
				
				fileReader.onload = (e) => {
					let contenidoArchivoXml=e.target.result;

					let retencionesPorArchivo = importarRetencionesDesdeXml(contenidoArchivoXml);
					let retencionesNuevas = retencionesPorArchivo.filter(ret1 => !this.state.retenciones.some(ret2 => ret2.ClaveAcceso===ret1.claveacceso));
					if( retencionesNuevas.length>0 ){

						const ultimoIndex = this.state.retenciones.length;

						this.setState({retenciones: [...this.state.retenciones, 
							...retencionesNuevas.map((retencion, i) => ({
								NroItem: (i+ultimoIndex+1),
								ClaveAcceso: retencion.claveacceso,
								FechaEmision: retencion.femi,
								Ruc: retencion.ruc,
								NombreCliente: retencion.nomcli,
								Establecimiento: retencion.esta,
								PtoEmision: retencion.emi,
								Secuencial: retencion.secuencial,
								DocRetener: retencion.numdoc,
								BaseRetIva: retencion.baseiva,
								PorcRetIva: retencion.pretiva,
								ValRetIva: retencion.valretiva,
								BaseRetFuente: retencion.baseFte,
								PorcRetFuente: retencion.pretfte,
								ValRetFuente: retencion.valretfte}))
							], arhivosCargados: this.state.arhivosCargados + 1
						});
					}
				}
			}			
		});		
	}

	limpiarDatos(visualizarRezagadas){	
		let fechaProceso = getFechaProcesoPorModulo('05');
		let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");	
		this.setState({ retenciones: [], visualizarRezagadas, arhivosCargados: 0,
						procesando: false, loteGenerado: null,fechaDesde: fechaDesde });
	}	

	handleImprimir(){
		if(this.state.loteGenerado){				
			visualizarReporteEnPdf('&rpt=139&param1=' + this.state.loteGenerado);
		}else{
			alert('No existe un lote de retenciones procesadas para imprimir.');
		}
	}

	procesarRetenciones(){	
		
		if( this.state.retenciones.length===0){
			alert('No ha importado archivos xml de retenciones electrónicas.');
			return;
		}

		let validPermiso = validarPermisoAcceso('G', this.props.permiso);
		if (!validPermiso.esValido){
			alert(validPermiso.msg);
			return;
		}

		let loteRetenciones = {
			Fecha: formatearFechaMoment_a_String(this.state.fecha),
			Usuario: getItemDatosSesion('usuario').toString(),
			EsLoteDeRezagadas: false,
			TipoFecha: this.state.tipoPeriodo,
			FechaContable: formatearFechaMoment_a_String(this.state.fechaDesde),
			Retenciones: this.state.retenciones

		};

		this.props.cambiar_VisualizacionLoading(true);
		this.setState({procesando: true});

		global_axios({
			method: 'POST',
			url: '/retenciones-electronicas-recibidas',
			data: loteRetenciones
		})
		.then( response => {
			this.props.cambiar_VisualizacionLoading(false);			

			if(response.data.resultado){
				if(response.data.resultado.retencionesProcesadas){				
					this.actualizarResultadoDeRetenciones(false, response.data.resultado.retencionesProcesadas);
				}
				this.setState({loteGenerado: response.data.resultado.lote});
			}
			
			alert('Las retenciones fueron procesadas. Para conocer el resultado de cada una revise las columnas Resultado y Observación.');
		})
		.catch( error => {
			this.props.cambiar_VisualizacionLoading(false);			
      		alert(error.response?error.response.data.msg:error.message);
		});
	}

	importarRetencionesResagadas(){	

		let toDate = new Date();
		let tempDate = new Date();
		let fromDate = new Date(tempDate.setDate(tempDate.getDate() - 30));

		this.props.cambiar_VisualizacionLoading(true);

		let query = '?Estado=E';
		query += this.state.rucCliente.trim().length>0?'&Ruc='+this.state.rucCliente.trim():'';
		query += '&From=' + fromDate.getFullYear() + '-' + (fromDate.getMonth()+1) + '-' + fromDate.getDate();
		query += '&To=' + toDate.getFullYear() + '-' + (toDate.getMonth()+1) + '-' + toDate.getDate();

		global_axios({
			method: 'GET',
			url: '/retenciones-electronicas-recibidas' + query
		})
		.then( response => {
			this.props.cambiar_VisualizacionLoading(false);

			this.setState({retenciones: response.data.map((retencion, i) => ({
										NroItem: (i+1),
										ClaveAcceso: retencion.ClaveAcceso,
										FechaEmision: retencion.FechaEmision,
										Ruc: retencion.Ruc,
										NombreCliente: retencion.NombreCliente,
										Establecimiento: retencion.Pestablecimiento,
										PtoEmision: retencion.PEmision,
										Secuencial: retencion.Secuencial,
										DocRetener: retencion.DocRetencion,
										BaseRetIva: retencion.BaseRetIva,
										PorcRetIva: retencion.PRetIva,
										ValRetIva: retencion.ValRetIva,
										BaseRetFuente: retencion.BaseRetFuente,
										PorcRetFuente: retencion.PRetFte,
										ValRetFuente: retencion.ValRetFte,
										LoteOriginal: retencion.Id_Carga,
										SecOriginal: retencion.Sec,
										Observacion: retencion.Observacion
									}))
						});
		})
		.catch( error => {
			this.props.cambiar_VisualizacionLoading(false);
      		alert(error.response?error.response.data.msg:error.message);
		});
	}

	reprocesarRetenciones(){

		let retencionesSeleccionadas = this.gridRetencionesApi.getSelectedRows();

		if( retencionesSeleccionadas.length===0 ){
			alert('No ha seleccionado las retenciones que desea reprocesar.');
			return;
		}

		let validPermiso = validarPermisoAcceso('G', this.props.permiso);
		if (!validPermiso.esValido){
			alert(validPermiso.msg);
			return;
		}		
	
		let loteRetenciones = {
			Fecha: formatearFechaMoment_a_String(this.state.fecha),
			Usuario: getItemDatosSesion('usuario').toString(),
			EsLoteDeRezagadas: true,
			TipoFecha: this.state.tipoPeriodo,
			FechaContable: formatearFechaMoment_a_String(this.state.fechaDesde),
			Retenciones: retencionesSeleccionadas
		};

		this.props.cambiar_VisualizacionLoading(true);
		this.setState({procesando: true});

		global_axios({
			method: 'POST',
			url: '/retenciones-electronicas-recibidas',
			data: loteRetenciones
		})
		.then( response => {
			this.props.cambiar_VisualizacionLoading(false);			

			if(response.data.resultado){
				if(response.data.resultado.retencionesProcesadas){				
					this.actualizarResultadoDeRetenciones(true, response.data.resultado.retencionesProcesadas);
				}
				this.setState({loteGenerado: response.data.resultado.lote});
			}

			this.setState({visualizarRezagadas: false});
			alert('Las retenciones seleccionadas fueron reprocesadas. Para conocer el resultado de cada una revise las columnas Resultado y Observación.');
		})
		.catch( error => {
			this.props.cambiar_VisualizacionLoading(false);
			alert(error.response?error.response.data.msg:error.message);
		});
	}
	

	actualizarResultadoDeRetenciones(esLoteDeRezagadas, retencionesProcesadas){
		if(!esLoteDeRezagadas){
			this.setState({retenciones: 
				this.state.retenciones.map(retencion => {
					let retencionProcesada = retencionesProcesadas.find(retProcesada => retProcesada.ClaveAcceso===retencion.ClaveAcceso);
					
					return {
						...retencion,
						Resultado: retencionProcesada?(retencionProcesada.Estado==='P'?'OK':'NOK'):'DESCONOCIDO',
						Observacion: retencionProcesada?retencionProcesada.Observacion:'No Hay Resultado del Proceso'
					};
				})
			});	
		}else{
			let retencionesSeleccionadas = this.gridRetencionesApi.getSelectedRows();
			this.setState({retenciones: 
				retencionesSeleccionadas.map((retencion, i) => {
					let retencionProcesada = retencionesProcesadas.find(retProcesada => retProcesada.ClaveAcceso===retencion.ClaveAcceso);
					
					return {
						...retencion,
						NroItem: i+1,
						Resultado: retencionProcesada?(retencionProcesada.Estado==='P'?'OK':'NOK'):'DESCONOCIDO',
						Observacion: retencionProcesada?retencionProcesada.Observacion:'No Hay Resultado del Proceso'
					};
				})
			});	
		}	
	}

	render(){

		return(
			<ContenedorForm porc_ancho={90}>
				<HeaderForm>
					<TituloForm>Procesamiento Masivo de Retenciones Electrónicas Recibidas</TituloForm>
				</HeaderForm>
				<CuerpoForm>
				
				<Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Periodo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-10'>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='S' checked={this.state.tipoPeriodo==='S'} onChange={this.handleInputChange} />
                                Por Fecha Emision
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='M' checked={this.state.tipoPeriodo==='M'} onChange={this.handleInputChange} />
                                Por Fecha Contable
                            </LabelForm>
                        </ContainerCol>
                </Row>
				<Row margen_arriba={10} isInvisible={this.state.tipoPeriodo!=='M'}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha Contable:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                </Row>
				<Row margen_arriba={10}>
				<ContainerCol className="col-sm-12">
					<Tabs onSelect={(tabIndex) => this.limpiarDatos(tabIndex===1?true:false)}>
								<TabList>
									<Tab>Retenciones nuevas</Tab>
									<Tab>Retenciones rezagadas</Tab>
								</TabList>
								<TabPanel>
									<Row>
										<ContainerCol className="col-sm-4">
											<input type="file" id="file-selector" accept=".xml" multiple
												onChange={this.handleFileUploaderOnChange}/>											
										</ContainerCol>
										<ContainerCol className="col-sm-4">
											<LabelContadorArchivos>Puede añadir como máximo: {this.state.maxArchivosRetencionPorLote} archivos (no se aceptan duplicados). Total añadidos: {this.state.arhivosCargados}</LabelContadorArchivos>
										</ContainerCol>
										<ContainerCol className="col-sm-4">
											<div className="btn-group pull-right" role="group" aria-label="...">
												<button type="button" className="btn btn-primary" onClick={this.procesarRetenciones}
													disabled={this.state.procesando}>
													<i className="fa fa-cog fa-lg" aria-hidden="true"></i>
													<span className="sr-only">Procesando...</span> Procesar
												</button>
												<button type='button' className='btn btn-info' onClick={this.handleImprimir}><i className='fa fa-print fa-lg'/> Imprimir</button>
												<button type="button" className="btn btn-default" onClick={()=>this.limpiarDatos(false)}>
													<i className="fa fa-trash fa-lg"></i>Limpiar
												</button>
											</div>
										</ContainerCol>
									</Row>
								</TabPanel>
								<TabPanel>
									<Row>
										<ContainerCol className="col-sm-2">											
											<h6><b>Ruc de Cliente</b>:</h6>
										</ContainerCol>
										<ContainerCol className="col-sm-3">	
											<input type="text" className="form-control input-sm" id="rucCliente" name="rucCliente" value={this.state.rucCliente} maxLength={13} onChange={this.handleInputChange}/>											
										</ContainerCol>
										<ContainerCol className="col-sm-7">
											<div className="btn-group pull-right" role="group" aria-label="...">
												<button type="button" className="btn btn-success" onClick={this.importarRetencionesResagadas}
													disabled={this.state.procesando}>
													<i className="fa fa-search fa-lg"></i> Buscar
												</button>
												<button type="button" className="btn btn-primary" onClick={this.reprocesarRetenciones}
													disabled={this.state.procesando}>
													<i className="fa fa-cogs fa-lg" aria-hidden="true"></i>
													<span className="sr-only">Reprocesando...</span> Reprocesar
												</button>
												<button type='button' className='btn btn-info' onClick={this.handleImprimir}><i className='fa fa-print fa-lg'/> Imprimir</button>
												<button type="button" className="btn btn-default" onClick={()=>this.limpiarDatos(true)}>
													<i className="fa fa-trash fa-lg"></i> Limpiar
												</button>
											</div>
										</ContainerCol>
									</Row>
								</TabPanel>
							</Tabs>
						</ContainerCol>
						
					</Row>
					<Row>
						<ContainerCol className="col-sm-12">
							<AgGridRender
								altura='420px'
								data={this.state.retenciones}
								columnas={!this.state.visualizarRezagadas?columnasGridRetenciones:columnasGridRetencionesResagadas}
								onGridReady={this.onGridReady}
								gridOptions={this.gridRetencionesOptions}
							/>
						</ContainerCol>
					</Row>
				
				</CuerpoForm>				
			</ContenedorForm>
		);
	}
}

const importarRetencionesDesdeXml = (xml) => {

	let retenciones=[];

	try {
		
		const xmlCompletoEnJson = convertXmlToJson.xml2js(xml, {compact: true, spaces: 4});
		const comprobanteRetencionEnJson = convertXmlToJson.xml2js(xmlCompletoEnJson.autorizacion.comprobante._cdata, {compact: true, spaces: 4});
		
		let amb, claveacceso, ruc, esta, emi, secuencial, codret1, baseiva=0, pretiva=0, valretiva=0, femi, numdoc, codret2, baseFte=0, pretfte=0, valretfte=0, ind1, ind2, nomcli, versionr;
		
		if(comprobanteRetencionEnJson.comprobanteRetencion){
			
			versionr=comprobanteRetencionEnJson.comprobanteRetencion._attributes.version;
			
			amb = comprobanteRetencionEnJson.comprobanteRetencion.infoTributaria.ambiente._text;
			
			
			if (amb==='2'){
				femi = comprobanteRetencionEnJson.comprobanteRetencion.infoCompRetencion.fechaEmision._text;
				claveacceso = comprobanteRetencionEnJson.comprobanteRetencion.infoTributaria.claveAcceso._text;
				ruc = comprobanteRetencionEnJson.comprobanteRetencion.infoTributaria.ruc._text;
				nomcli = comprobanteRetencionEnJson.comprobanteRetencion.infoTributaria.razonSocial._text;
				esta = comprobanteRetencionEnJson.comprobanteRetencion.infoTributaria.estab._text;
				emi = comprobanteRetencionEnJson.comprobanteRetencion.infoTributaria.ptoEmi._text;
				secuencial = comprobanteRetencionEnJson.comprobanteRetencion.infoTributaria.secuencial._text;

				if (versionr==='1.0.0')
				{
						if (Array.isArray(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto)){			
							codret1 = comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[0].codigo;
							codret2 = comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[1].codigo;
							ind2 = codret1._text==='1'?1:0;			
							baseiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[ind2].baseImponible._text);
							pretiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[ind2].porcentajeRetener._text);
							valretiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[ind2].valorRetenido._text);
							ind1 = codret2._text==='2'?0:1;
							baseFte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[ind1].baseImponible._text);
							pretfte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[ind1].porcentajeRetener._text);
							valretfte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[ind1].valorRetenido._text);
							numdoc = comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto[ind1].numDocSustento._text;
						}else{
							codret1 = comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.codigo;
							if (codret1._text==='2'){
								baseiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.baseImponible._text);
								pretiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.porcentajeRetener._text);
								valretiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.valorRetenido._text);
								numdoc = comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.numDocSustento._text;
							}

							if (codret1._text==='1'){
								baseFte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.baseImponible._text);
								pretfte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.porcentajeRetener._text);
								valretfte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.valorRetenido._text);
								numdoc = comprobanteRetencionEnJson.comprobanteRetencion.impuestos.impuesto.numDocSustento._text;
							}
						}			
				} else //if (versionr==='2.0.0') lee esta version
				{
						if (Array.isArray(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion)){			
							codret1 = comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion[0].codigo;
							codret2 = comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion[1].codigo;
							ind2 = codret1._text==='1'?1:0;			
							baseiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion[ind2].baseImponible._text);
							pretiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion[ind2].porcentajeRetener._text);
							valretiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion[ind2].valorRetenido._text);
							ind1 = codret2._text==='2'?0:1;
							baseFte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion[ind1].baseImponible._text);
							pretfte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion[ind1].porcentajeRetener._text);
							valretfte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion[ind1].valorRetenido._text);
							numdoc = comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.numDocSustento._text;
						}else{
							codret1 = comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion.codigo;
							if (codret1._text==='2'){
								baseiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion.baseImponible._text);
								pretiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion.porcentajeRetener._text);
								valretiva = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion.valorRetenido._text);
								numdoc = comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.numDocSustento._text;
							}

							if (codret1._text==='1'){
								baseFte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion.baseImponible._text);
								pretfte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion.porcentajeRetener._text);
								valretfte = parseFloat(comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.retenciones.retencion.valorRetenido._text);
								numdoc = comprobanteRetencionEnJson.comprobanteRetencion.docsSustento.docSustento.numDocSustento._text;
							}
						}			
				}


				retenciones.push({
					claveacceso, femi, ruc, esta, emi, secuencial, baseiva, pretiva, valretiva, numdoc, baseFte, pretfte, valretfte, nomcli
				});
				
			}
		}

	} catch (error) {
		console.log('No se pudo importar el archivo seleccionado: %s', error);
	}
	return retenciones;
}

const mapStateToProps = ((state) => {
	return {
		isVisibleLoading: state.ui.isVisibleLoading,		
		permiso: state.sesion.valoresSesionForm.Permiso
	};
});

const mapDispatchToProps = ((dispatch) => {  
	return bindActionCreators({
		cambiar_VisualizacionLoading,
		generar_LogAuditoriaIngresoForm,
		generar_LogAuditoriaSalidaForm
	}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCaja09);